import * as React from 'react';
import { Grid } from '@mui/material';
import { IconLabelButton } from './Buttons';
import { BuildingComponent } from './Building';
import { Building, KakaoAddress } from '../../types';

interface TerritoryInfoProps {
  buildings: Building[];
  currAddress: KakaoAddress;
  editable: boolean;
  handleBuildingAdd: () => void;
  handleBuildingUpdate: (id: number, name: string, address: string) => void;
  handleBuildingDelete: (id: number) => () => void;
}

export function TerritoryInfo({
  buildings,
  currAddress,
  editable,
  handleBuildingAdd,
  handleBuildingUpdate,
  handleBuildingDelete,
}: TerritoryInfoProps) {
  return (
    <>
      {buildings.map((building: Building) => (
        <Grid key={`building-${building.id}`} item xs={12}>
          <BuildingComponent
            building={building}
            handleBuildingUpdate={handleBuildingUpdate}
            handleBuildingDelete={handleBuildingDelete}
            currAddress={currAddress}
            editable={editable}
          />
        </Grid>
      ))}
      <IconLabelButton
        visible={editable}
        iconName="add"
        label="건물추가"
        onClick={handleBuildingAdd}
      />
    </>
  );
}
